import { useNavigate } from 'react-router-dom';
import useAuthStore from '@/store/useAuthStore';
import { usePageBackground } from '@/hooks/usePageBackground';
import './MetadataError.css';

/**
 * MetadataError - Error page shown when metadata is corrupted or invalid
 * Shows friendly message and allows user to re-login
 */
export default function MetadataError() {
  const navigate = useNavigate();
  const clearAuthState = useAuthStore(state => state.clearAuthState);

  // Set error background via Asset system
  usePageBackground('bg.error');

  const handleRelogin = () => {
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear auth state
    clearAuthState();

    // Redirect to home
    navigate('/');
  };

  return (
    <div className="metadata-error-screen">
      <div className="metadata-error-container">
        <div className="error-icon">⚠️</div>
        <h1 className="error-title">Parece que algo salió mal</h1>
        <p className="error-message">
          Necesitamos que vuelvas a iniciar sesión para cargar los datos del juego correctamente.
        </p>
        <button className="relogin-button" onClick={handleRelogin}>
          Volver a iniciar sesión
        </button>
        <p className="debug-hint">
          💡 Si eres desarrollador, revisa la consola para más detalles
        </p>
      </div>
    </div>
  );
}
